export class Player {
  constructor ({ id = null, strikes = [], score = 0 } = {}) {
    this.id = id
    this.strikes = strikes
    this.score = score
    this.total_strikes = 0
  }

  // set id( id ) {
  //   this.id = id
  // }

  // get id () {
  //   return this.id
  // }

  get totalStrikes () {
    return this.strikes.reduce((acc, strike) => acc + strike.value, 0)
  }
}

export default function createPlayer (data) {
  return new Player(data)
}
